import { createFileRoute } from "@tanstack/react-router";
import { MarketingHeader } from "@/components/marketing/marketing-header";
import { HeroSection } from "@/components/marketing/hero-section";
import { SocialProofTicker } from "@/components/marketing/social-proof-ticker";
import { FeaturesSection } from "@/components/marketing/features-section";
import { DemoSection } from "@/components/marketing/demo-section";
import { AreasSection } from "@/components/marketing/areas-section";
import { TracciabilitaSection } from "@/components/marketing/tracciabilita-section";
import { AudienceSection } from "@/components/marketing/audience-section";
import { ContactSection } from "@/components/marketing/contact-section";
import { HowItWorksSection, FinalCTASection } from "@/components/marketing/how-it-works";
import { TestimonialsSection } from "@/components/marketing/testimonials-section";
import { SecuritySection } from "@/components/marketing/security-section";
import { PricingSection } from "@/components/marketing/pricing-section";
import { FaqSection } from "@/components/marketing/faq-section";
import { MarketingFooter } from "@/components/marketing/marketing-footer";
import { seoMeta } from "@/lib/seo/head";
import {
  JsonLd,
  organizationSchema,
  websiteSchema,
  softwareAppSchema,
  faqSchema,
} from "@/components/seo/json-ld";

const HOMEPAGE_FAQS = [
  { q: "LexAIPro può sostituire un avvocato?", a: "No. LexAIPro è uno strumento professionale che assiste e amplifica il giudizio dell'avvocato, non lo sostituisce. Le decisioni legali finali restano sempre del professionista." },
  { q: "I miei documenti sono al sicuro?", a: "Sì. Applichiamo una zero retention policy: i documenti vengono eliminati dai nostri server dopo l'elaborazione e i tuoi dati non vengono mai usati per addestrare i modelli AI." },
  { q: "Funziona solo per il diritto italiano?", a: "Il sistema è ottimizzato per il diritto italiano (codici, leggi, giurisprudenza), con copertura del diritto europeo. Stiamo espandendo la copertura ad altri ordinamenti UE." },
  { q: "Posso provarlo gratis?", a: "Sì, offriamo 14 giorni di prova gratuita su tutti i piani senza richiedere carta di credito. Puoi annullare in qualsiasi momento." },
  { q: "Quali documenti posso analizzare?", a: "Tutti i principali formati: PDF, DOCX, DOC, TXT, RTF, HTML, ODT. Massimo 50 MB per file e fino a 10 file per upload." },
  { q: "Le citazioni sono affidabili?", a: "LexAIPro cita sempre la fonte normativa o giurisprudenziale. Per aree in rapida evoluzione segnaliamo esplicitamente la necessità di verificare aggiornamenti recenti." },
  { q: "Posso integrarlo con il mio gestionale?", a: "Sì. Il piano Studio include API access, con integrazioni native per Google Workspace, Microsoft 365, DocuSign e altri tool." },
  { q: "Cosa succede se supero le query incluse?", a: "Sul piano Starter mostriamo un avviso al raggiungimento del limite e puoi fare upgrade in un click. Sul piano Professional le query sono illimitate." },
];

export const Route = createFileRoute("/")({
  head: () =>
    seoMeta({
      title: "Ricerca legale AI tracciabile per avvocati - LexAIPro",
      description:
        "AI giuridica per avvocati italiani: ricerca legale in linguaggio naturale, analisi documenti e redazione assistita con tracciabilità di ogni citazione. 14 giorni gratis.",
      path: "/",
    }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background">
      <JsonLd data={[organizationSchema(), websiteSchema(), softwareAppSchema(), faqSchema(HOMEPAGE_FAQS)]} />
      <MarketingHeader />
      <main>
        <HeroSection />
        <SocialProofTicker />
        <FeaturesSection />
        <TracciabilitaSection />
        <DemoSection />
        <AreasSection />
        <HowItWorksSection />
        <AudienceSection />
        <TestimonialsSection />
        <SecuritySection />
        <PricingSection />
        <FaqSection />
        <ContactSection />
        <FinalCTASection />
      </main>
      <MarketingFooter />
    </div>
  );
}
